import { call, put, takeLatest, fork, all, delay, } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as ObjectTypeService from './../services/objectTypeService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import { parseRatingListRequestParams } from '../utils/commonUtils';
import { notification } from 'antd'
import {
    setObjectTypeDetail,
    setObjectTypes, setAllObjectType
} from './../actions/objectTypeAction';
import history from '../helpers/history';

function* getListObjectType() {
    yield takeLatest(Types.OBJECT_TYPE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        const result = yield call(ObjectTypeService.getObjectType, params);
        yield put(setObjectTypes(result));
    }, errorHandleObjectType(Types.OBJECT_TYPE_LIST_FAIL)))
}

function* getAllObjectType() {
    yield takeLatest(Types.OBJECT_TYPE_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(ObjectTypeService.getAllObjectType, action.filters);
        yield put(setAllObjectType(result));
    }, errorHandleObjectType(Types.OBJECT_TYPE_LIST_FAIL)))
}

function* getObjectTypeDetail() {
    yield takeLatest(Types.OBJECT_TYPE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(ObjectTypeService.getObjectTypeDetail, action.id);
        yield put(setObjectTypeDetail(result));
    }, errorHandleObjectType(Types.OBJECT_TYPE_DETAIL_FAIL)))
}

function* updateObjectTypeDetail() {
    yield takeLatest(Types.OBJECT_TYPE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(ObjectTypeService.updateObjectTypeDetail, action.objectType.objectType);
        successHandleObjectType(action, action.objectType.objectType.name);
        yield put(setObjectTypeDetail(action.objectType.objectType));
        history.push(PATHS.OBJECT_TYPES.LIST.path);
        history.go();
    }, errorHandleObjectType(Types.OBJECT_TYPE_DETAIL_FAIL)))
}

function* createObjectTypeDetail() {
    yield takeLatest(Types.OBJECT_TYPE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(ObjectTypeService.createObjectTypeDetail, action.objectType);
        successHandleObjectType(action, action.objectType.name);
        yield put(setObjectTypeDetail(result));
        history.push(PATHS.OBJECT_TYPES.LIST.path);
        history.go();
    }, errorHandleObjectType(Types.OBJECT_TYPE_DETAIL_FAIL)))
}

function* deleteObjectTypeDetail() {
    yield takeLatest(Types.OBJECT_TYPE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(ObjectTypeService.deleteObjectTypeDetail, action.objectType);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseRatingListRequestParams(action.filter || {});
        const resultList = yield call(ObjectTypeService.getObjectType, params);
        yield put(setObjectTypes(resultList));
    }, errorHandleObjectType(Types.OBJECT_TYPE_DETAIL_FAIL)));
}


/* Transtale Saga */

function* createObjectTypeTranslate() {
    yield takeLatest(Types.OBJECT_TYPE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ObjectTypeService.createObjectTypeTranslate, action.objectType);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.objectType.translate.languageName);
        yield put({ type: Types.OBJECT_TYPE_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.OBJECT_TYPE_DETAIL_ACTION, id: action.objectType.id });
    }, errorHandleObjectType(Types.OBJECT_TYPE_FAIL)))
}

function* updateObjectTypeTranslate() {
    yield takeLatest(Types.OBJECT_TYPE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ObjectTypeService.updateObjectTypeTranslate, action.objectType);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.objectType.translate.languageName);
        yield put({ type: Types.OBJECT_TYPE_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.OBJECT_TYPE_DETAIL_ACTION, id: action.objectType.id });
    }, errorHandleObjectType(Types.OBJECT_TYPE_FAIL)))
}

function* deleteObjectTypeTranslate() {
    yield takeLatest(Types.OBJECT_TYPE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(ObjectTypeService.deleteObjectTypeTranslate, action.objectType.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.objectType.translate.languageName);
        yield put({ type: Types.OBJECT_TYPE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.OBJECT_TYPE_DETAIL_ACTION, id: action.objectType.id });
    }, errorHandleObjectType(Types.OBJECT_TYPE_FAIL)))
}

function successHandleObjectType(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.objectType.title')} "${value}"`
    })
}


function errorHandleObjectType(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'objectType');
}

export function* objectTypeSaga() {
    yield all([
        fork(getListObjectType),
        fork(getObjectTypeDetail),
        fork(updateObjectTypeDetail),
        fork(createObjectTypeDetail),
        fork(createObjectTypeTranslate),
        fork(updateObjectTypeTranslate),
        fork(deleteObjectTypeDetail),
        fork(deleteObjectTypeTranslate),
        fork(getAllObjectType)
    ])
}
